module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-35.b770db40.png";